<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["BirimId", "DonemId", "Sorgulama", "AltDonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TabloVerileri: [],
      TabloDetayVerileri: [],
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi: [],
      RiskDegerler: [],
      RiskDetaylar: [],
      donem_yili: "",
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
  },

  methods: {
    Get() {
      this.bugun = new Date();
      this.RiskDegerler = [];

      this.ActionsGet({
        Service: "StrPerfDonem/" + this.AltDonemId,
        Page: this.Page,
      }).then((res2) => {
        this.donem_yili = res2.Data.YilBas;
      });

      let Filter = "&Donemid=" + this.AltDonemId;
      if (this.BirimId) {
        Filter += "&Birimid=" + this.BirimId;
      }

      this.ActionsFilterGet({
        Service: "StrRiskDeger",
        Page: this.Page,
        Filter: Filter,
      }).then((res3) => {
        this.RiskDegerler = res3.Data;

        let riskMap = new Map();

        this.RiskDegerler.forEach((risk) => {
          let riskId = risk.Riskid;

          if (!riskMap.has(riskId)) {
            riskMap.set(riskId, {
              Riskid: riskId,
              Riskadi: risk.StrRisk,
              EtkiToplam: 0,
              OlasilikToplam: 0,
              PuanToplam: 0,
              OylamaSayisi: 0,
              Detay: [],
            });
          }

          let riskObj = riskMap.get(riskId);
          riskObj.EtkiToplam += risk.Etki;
          riskObj.OlasilikToplam += risk.Olasilik;
          riskObj.PuanToplam += risk.Riskpuani;
          riskObj.OylamaSayisi++;

          riskObj.Detay.push({
            Adisoyadi: risk.Adisoyadi,
            Etki: risk.Etki,
            Olasilik: risk.Olasilik,
            Riskpuani: risk.Riskpuani,
            Degerlendirme: risk.Degerlendirme,
          });
        });

        this.RiskDetaylar = Array.from(riskMap.values()).map((risk) => ({
          Riskid: risk.Riskid,
          Riskadi: risk.Riskadi,
          OylamaSayisi: risk.OylamaSayisi,
          EtkiOrtalama: Math.round(
            risk.EtkiToplam / risk.OylamaSayisi
          ).toString(),
          OlasilikOrtalama: Math.round(
            risk.OlasilikToplam / risk.OylamaSayisi
          ).toString(),
          PuanOrtalama: Math.round(
            risk.PuanToplam / risk.OylamaSayisi
          ).toString(),
          Detay: risk.Detay.sort(this.buyuktenKucugeSiralama),
        }));

        console.log(this.RiskDetaylar);
      });
    },

    buyuktenKucugeSiralama(a, b) {
      return b.Riskpuani - a.Riskpuani;
    },
    renk(Data) {
      if (Data == "Yüksek Risk") {
        return "red";
      }
      if (Data == "Düşük Risk") {
        return "green";
      }
      if (Data == "Orta Risk") {
        return "yellow";
      }

      if (Data == "Çok Yüksek") {
        return "#800000";
      }
      if (Data == "Yüksek") {
        return "red";
      }
      if (Data == "Orta") {
        return "orange";
      }
      if (Data == "Düşük") {
        return "yellow";
      }
      if (Data == "Çok Düşük") {
        return "green";
      }
    },
    ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.riskoylama;
      var html = table.innerHTML;
      var ctx = { worksheet: name || "Worksheet", table: html };
      var a = document.createElement("a");
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + ".xls";
      a.click();
    },
  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
    <div class="text-sm-end">
      <button
        type="button"
        class="btn btn-success btn-rounded mb-2 me-2"
        @click="ExcelExport('Risk Oylama Raporu', 'Risk Oylama Raporu')"
      >
        <i class="mdi mdi-file-export-outline me-1"></i>
        Excel'e Aktar
      </button>
    </div>

    <div ref="riskoylama" class="table-responsive">
      <div class="table-responsive">
        <table style="width:100%">
          <tr>
            <td colspan="6" style="text-align: center;">
              <div><h4>RİSK OYLAMA RAPORU</h4></div>
            </td>
          </tr>
          <tr>
            <td colspan="6" style="text-align: center;">
              <div>
                <h4>{{ donem_yili }} Risk Yönetimi</h4>
              </div>
            </td>
          </tr>
        </table>

        <br />

        <table
          style="border: 1px solid; border-collapse: collapse; "
          border="1"
          class="table  table-md table-bordered border-success mb-0"
        >
          <template v-for="Riskler in RiskDetaylar">
            <thead
              class="table-light"
              style="text-align: center; "
              :key="Riskler.Riskid"
            >
              <tr>
                <th>Risk</th>
                <th colspan="5" style="text-align: left;">
                  {{ Riskler.Riskadi }}
                </th>
              </tr>
              <tr style="text-align: center; font-weight: bold;">
                <td>Sıra</td>
                <td>Ad Soyad</td>
                <td>Etki</td>
                <td>Olasılık</td>
                <td>Risk Puanı</td>
                <td>Değerlendirme</td>
              </tr>
            </thead>
            <tbody v-for="(Risk, index) in Riskler.Detay" :key="index">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ Risk.Adisoyadi }}</td>
                <td style="text-align: center;">{{ Risk.Etki }}</td>
                <td style="text-align: center;">{{ Risk.Olasilik }}</td>
                <td
                  class="text-center"
                  :style="{ background: renk(Risk.Degerlendirme) }"
                >
                  <span style="color: black">{{
                    Math.round(Risk.Riskpuani)
                  }}</span>
                </td>
                <td class="text-center">{{ Risk.Degerlendirme }}</td>
              </tr>
            </tbody>

            <tbody :key="Riskler.Riskid">
              <tr>
                <td style="font-weight: bold ;" colspan="2">Ortalama Puan</td>
                <td style="text-align: center;">{{ Riskler.EtkiOrtalama }}</td>
                <td style="text-align: center;">
                  {{ Riskler.OlasilikOrtalama }}
                </td>
                <td style="text-align: center;">
                  {{ Riskler.EtkiOrtalama * Riskler.OlasilikOrtalama }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>
